import { ImageProps } from './ImageComponent.models';
import { Img } from './ImageComponent.styles';

const ImageComponent: React.FC<ImageProps> = (props) => <Img {...props} />;

export default ImageComponent;
